import pImg1 from '../images/apartment/apartment1.png'
import pImg2 from '../images/apartment/apartment2.png'
import pImg3 from '../images/apartment/apartment3.png'


import pSImg1 from '../images/apartment/apartment1.png'
import pSImg2 from '../images/apartment/apartment2.png'
import pSImg3 from '../images/apartment/apartment3.png'

import sIcon1 from '../images/apartment/icon1.png'
import sIcon2 from '../images/apartment/icon2.png'
import sIcon3 from '../images/apartment/icon3.png'


const Projects = [
    {
        Id: '1',
        pTitle: 'Architecture', 
        slug: 'Architecture',
        pImg:pImg1,
        pSImg:pSImg1,
        ssIcon:sIcon1,
        des:'We have the best architecture in the UAE',
        width:'120',
    },
    {
        Id: '2',
        pTitle: 'Exterior Design', 
        slug: 'Exterior-Design',
        pImg:pImg2,
        pSImg:pSImg2,
        ssIcon:sIcon2,
        des:'The engineer will create an exterior design',
        width:'130',
    },
    {
        Id: '3',
        pTitle: 'Interior', 
        slug: 'Interior',
        pImg:pImg3,
        pSImg:pSImg3,
        ssIcon:sIcon3,
        des:'Then the interior will be complested',
        width:'140',
    },
    {
        Id: '4',
        pTitle: 'Furniture & Decor', 
        slug: 'Furniture-&-Decor',
        pImg:pImg1,
        pSImg:pSImg1,
        ssIcon:sIcon1,
        des:'Aenean vehicula non mauris maximus elementum. Nulla facilisi.',
        width:'120',
    },
    {
        Id: '5',
        pTitle: 'Exclusive Home Decor', 
        slug: 'Exclusive-Home-Decor',
        pImg:pImg2,
        pSImg:pSImg2,
        ssIcon:sIcon2,
        des:'Aenean vehicula non mauris maximus elementum. Nulla facilisi.',
        width:'130',
    },
    {
        Id: '6',
        pTitle: 'Modern Architecture', 
        slug: 'Modern-Architecture',
        pImg:pImg3,
        pSImg:pSImg3,
        ssIcon:sIcon3,
        des:'Aenean vehicula non mauris maximus elementum. Nulla facilisi.',
        width:'140',
    }
]

export default Projects;